import UserEventCardComponents from './components/UserEventCardComponents';
import getUserLabelComponents from './components/getUserLabelComponents';
import SlideTab from './components/SlideTab';
import SlideTabVertical from './components/SlideTabVertical';
import getUserLabel from './helpers/getUserLabel';
import addMinutesToDate from './helpers/addMinutesToDate';
import formatDateTime from './helpers/formatDateTime';
import convertMinuteToHour from './helpers/convertMinuteToHour';
import formatCreditCardNumber from './helpers/formatCreditCardNumber';
import nFormatter from './helpers/nFormatter';
import addDaysToDate from './helpers/addDaysToDate';
import validateEmail from './helpers/validateEmail';
import airDatePickerLocale from './helpers/airDatePickerLocale';
import formatDate from './helpers/formatDate';
import clearField from './helpers/clearField';
import stripHtml from './helpers/stripHtml';
import getHtmlImage from './helpers/getHtmlImage';
import humanTime from './helpers/humanTime';
import windowScrollTop from './helpers/windowScrollTop';
import modalScrollTop from './helpers/modalScrollTop';
import userIsSuspended from './helpers/userIsSuspended';
import isMobile from './helpers/isMobile';
import cookies from './helpers/cookies';
export const components = {
  convertMinuteToHour,
  SlideTab,
  SlideTabVertical,
  addMinutesToDate,
  UserEventCardComponents,
  getUserLabelComponents,
  getUserLabel,
  formatDateTime,
  formatCreditCardNumber,
  validateEmail,
  addDaysToDate,
  nFormatter,
  airDatePickerLocale,
  formatDate,
  clearField,
  windowScrollTop,
  modalScrollTop,
  userIsSuspended,
  isMobile,
  cookies,
  stripHtml,
  getHtmlImage,
  humanTime,
  selectedCategory: ""
};
window.zivenCore = components;